import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { RequestHeaderComponent } from './request-header.component';
import { useDataRequestAdminPath } from '@vivli/features/data-requests/infrastructure/hook';
import { useAssignedAppTypeContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';

interface DataRequestHeaderComponentProps {
    onEditTitleClick?: () => void;
    onSaveClick?: () => void;
    onSubmitClick?: () => void;
    title?: string;
}

export const DataRequestHeaderComponent = ({ onEditTitleClick, onSaveClick, onSubmitClick, title }: DataRequestHeaderComponentProps) => {
    const { isAmr } = useAssignedAppTypeContext();
    const isDataRequestsView = useDataRequestAdminPath();
    const { dataRequest, organizations } = useDataRequestContext();
    const isDraft = dataRequest.status === DataRequestStatusEnum.Draft;
    const { userIsContributorOrIRPApprover } = useDataRequestPermissionsContext();

    const isContributorOrIRPApprover = userIsContributorOrIRPApprover(dataRequest, organizations);
    const myDataRequestDraft = !isDataRequestsView && isDraft;
    const myDataRequestNotDraft = !isDataRequestsView && !isDraft;
    const showSaveButtons = myDataRequestDraft || (isDraft && !isContributorOrIRPApprover);
    const showPrintButton = myDataRequestNotDraft || (isContributorOrIRPApprover && isDataRequestsView);
    const showCancelButton = isDraft && !isAmr;

    return (
        <RequestHeaderComponent
            onEditTitleClick={onEditTitleClick}
            onSaveClick={onSaveClick}
            onSubmitClick={onSubmitClick}
            title={title}
            showTrackingButton={false} //admin only
            showResetToDraftButton={false} //admin only
            showCancelButton={showCancelButton}
            showEditDataRequestButton={false} //admin only
            showSaveButtons={showSaveButtons}
            showEditTitleButton={showSaveButtons}
            showPrintButton={true}
            myDataRequests={true}
            showArchiveButton={false} //admin only
        />
    );
};
